export default {"src":"/encomendas-static/_next/static/media/height-icon.e6a584ba.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};